import React from 'react';

import Button from "@material-ui/core/Button";

function SelectButton (props) {
  const {
    value,
    options,
    onChange = () => {},
    children,
    ...other
  } = props;

  const valueIndex = options.findIndex (
    option => option.value === value);

  return (
    <Button onClick={() => onChange (options[(valueIndex + 1) % options.length].value)}
            {...other}>
      {options[valueIndex].title}
    </Button>
  );
}

export default SelectButton;
